// extracted by mini-css-extract-plugin
export default {"component":"PageTitle_component__IQbuA","icon":"PageTitle_icon__pKU-N","dark":"PageTitle_dark__HZRbg"};